import { faCogs } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
//import "./ScriptInfoCard.css";
import { Col, Dropdown, DropdownButton, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";

class ScriptInfoCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { t } = this.props;

    const body = (
      <>
        <Row className="pageTitle">
          <Col>
            <h2>{t("SingleScript.Title")}</h2>
          </Col>
          <Col>
            <div style={{ float: "right" }}>
              <DropdownButton
                onClick={event => event.stopPropagation()}
                id="dropdown-basic-button"
                title={<FontAwesomeIcon icon={faCogs} />}
                className="btn-green"
              >
                <Dropdown.Item onClick={this.props.onEdit}>
                  {t("SingleScript.ActionCell.EditOption")}
                </Dropdown.Item>
              </DropdownButton>
            </div>
          </Col>
        </Row>
        <Row className="mb-4">
          <Col>
            <div>
              <b>{t("SingleScript.BasicInformation.Name")}:</b>{" "}
              {this.props.script.name}
            </div>
          </Col>
          <Col style={{ borderLeft: "1px solid gray" }}>
            <div>
              <b>{t("SingleScript.BasicInformation.Type")}:</b>{" "}
              {this.props.script.type === 0
                ? "Powershell"
                : "Shell (Bash) Script"}
            </div>
          </Col>
        </Row>
      </>
    );

    return <div>{body}</div>;
  }
}

export default withTranslation()(ScriptInfoCard);
